
import { apiPost, apiDelete } from "./apiClient";

export async function createManualTransaction(payload) {
  return apiPost("/bank-report/manual-transaction", payload);
}

export async function deleteManualTransaction(id) {
  return apiDelete(`/bank-report/manual-transaction/${id}`);
}

export async function createInternalTransaction(payload) {
  return apiPost("/bank-report/internal-transaction", payload);
}